import {
  ADD_PREVIEW,
  ADD_ID,
  DELETE_ID,
  DELETE_PREVIEW
} from './mutations-types'

export default {
  [ADD_PREVIEW] (state, preview) {
    state.previews = [...state.previews, preview]
  },
  [ADD_ID] (state, id) {
    state.ids = [...state.ids, id]
  },
  [DELETE_PREVIEW] (state, preview) {
    state.previews = state.previews.filter(p => p !== preview)
  },
  [DELETE_ID] (state, id) {
    state.ids = state.ids.filter(i => i !== id)
  }
}
